import script from "./object_simplePageText.vue?vue&type=script&setup=true&lang=js"
export * from "./object_simplePageText.vue?vue&type=script&setup=true&lang=js"

import "./object_simplePageText.vue?vue&type=style&index=0&id=ac07b1c8&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac07b1c8"]])

export default __exports__